import React, { useRef } from "react";
import { Box, MenuItem, SelectField } from '@curves/ui-base';

const GradesTypeSelector = ({ selectedType, onTypeChange }) => {
    const typeOptions = [
        { key: "type1", label: "體重(KG)", description: "體重數值排名" },
        { key: "type2", label: "體脂肪重(KG)", description: "體脂肪重量排名" },
        { key: "type3", label: "體脂肪率(%)", description: "體脂肪百分比排名" },
        { key: "type4", label: "骨骼肌重(KG)", description: "骨骼肌重量排名" },
        { key: "type5", label: "總體圍(CM)", description: "總體圍數值排名" }
    ];
    const typeRef = useRef(null);
    const handleChange = (event, node, value) => {
        onTypeChange(value);
    };
    return (
        <Box>         
            <SelectField
                key={selectedType}
                ref={typeRef}
                defaultValue={selectedType}
                onChange={handleChange}
                displayEmpty
                fullWidth
                label="選擇類型"
            >
                <MenuItem value="" disabled>
                    <em>請選擇</em>
                </MenuItem>
                {typeOptions.map((option) => (
                    <MenuItem key={option.key} value={option.key}>
                        {option.label}
                    </MenuItem>
                ))}
            </SelectField>
        </Box>
    );
};
export default GradesTypeSelector; 